import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useState } from 'react';
import { ROUTES } from 'base/routes/routes';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';

import { IoArrowBackCircle } from 'react-icons/io5';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@mui/material';

import {
  QCProductionModel,
  TestTargetProduction,
} from 'services/report_services';
import { reportPresenter, reportStore } from 'stores/root_store';

export function createCheckSMDetail() {
  return observer(() => {
    const column = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Số phiếu KT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Ngày KT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'LSX',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Số thẻ treo',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Tên SP',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Công đoạn KT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Số SP/Tờ/CĐ',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL sản xuất (Sản phẩm)',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Chỉ tiêu KT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL mẫu kiểm',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL đạt',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL không đạt',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'ĐVT công đoạn',
        align: 'text-center',
        visible: true,
      },
      // {
      //   columnName: "Lỗi",
      //   align: "text-center",
      //   visible: true,
      // },
      {
        columnName: 'Ghi chú',
        align: 'text-center',
        visible: true,
      },
    ];

    const columnDetails = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Thời gian KT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'NV kiểm tra',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL mẫu kiểm',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL đạt',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL không đạt',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'ĐVT công đoạn',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Lỗi',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Cách nhận biết',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Nguyên nhân',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Ghi chú',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Kết luận',
        align: 'text-center',
        visible: true,
      },
    ];
    const navigate = useNavigate();
    const { woCode = '', stepCode = '' } = useParams();

    //========================================================================================================== //
    //-------------------------------------------     STATE      -------------------------------------------------//
    //========================================================================================================== //

    const [loading, setLoading] = useState(true);
    // ============================ MODAL STATE ==================================
    const [openModel, setOpenModal] = useState(false);
    const [dataTable, setDataTable] = useState<QCProductionModel[]>([]);
    const [detailProduction, setDetailProduction] =
      useState<TestTargetProduction | null>(null);

    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //------------------------------------   HÀM LẤY DỮ LIỆU DÙNG CHUNG  ----------------------------------------//
    //========================================================================================================== //

    const getDataDetail = async () => {
      await reportPresenter.getDetailQCProction(reportStore, woCode, stepCode);
      if (reportStore.detailQCResponse.isSuccess) {
        setDataTable(reportStore.detailQCResponse.data);
      }
    };
    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------LOAD DỮ LIỆU-------------------------------------------------//
    //========================================================================================================== //

    useEffect(() => {
      const doInit = async () => {
        await getDataDetail();
        setLoading(false);
      };
      doInit();
    }, []);
    //=======================XXX========================XXX=========================XXX========================= //

    // =================================================================
    //                HANDLE MODAL                                    //
    // =================================================================
    const handleOpenModal = (testTargetProduction: TestTargetProduction) => {
      setDetailProduction(testTargetProduction);
      setOpenModal(true);
    };

    const handleClose = () => {
      setOpenModal(false);
    };
    // =================================================================

    return (
      <div className='w-full py-3 px-5'>
        <div className='header'>
          <div className='flex '>
            {/* <div className="text-center flex-1">
              <h2 className="text-md font-bold text-gray-800 mb-2 uppercase"> BÁO CÁO KIỂM TRA CÔNG ĐOẠN PHÒNG QC</h2>
            </div> */}
            {/* nút back */}
            <div className='flex items-center mb-3'>
              <h3 className='text-base font-bold text-gray-800 uppercase'>
                CHI TIẾT BÁO CÁO KIỂM TRA CÔNG ĐOẠN PHÒNG QC
              </h3>

              <span
                onClick={() => navigate(ROUTES.REPORTS.REPORT_MARKETING.LINK)}
                className='flex items-center text-xs text-primary cursor-pointer font-medium w-fit'
              >
                <IoArrowBackCircle className='mr-2 text-base text-gray-500' />
                Quay lại
              </span>
            </div>
          </div>
        </div>

        {/* table main */}
        <div className='main zone'>
          <div className='w-full bg-white p-3.5 rounded border border-neutral-300'>
            <div className='tableZOne'>
              <div className={`overflow-x-auto`}>
                <table className='w-full text-default table-auto break-all border-collapse space-collapse'>
                  <thead className=' text-white bg-[#4682B4]'>
                    <tr>
                      {column?.map((item, index) => {
                        if (item.visible) {
                          return (
                            <th
                              key={index}
                              scope='col'
                              className={`${item.visible ? '' : 'hidden'
                                } py-2 px-2 border text-left ${item.align
                                } break-normal font-medium text-default`}
                            >
                              {item.columnName}
                            </th>
                          );
                        }
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {dataTable.length ? (
                      dataTable.map((item, index) => {
                        return (
                          <Fragment key={index}>
                            {item.qcProductionReports.length &&
                              item.qcProductionReports.map((report, j) => (
                                <tr
                                  key={j}
                                  className='break-normal hover:bg-gray-100'
                                >
                                  {/* Số thứ tự */}
                                  <td className='whitespace-nowrap border p-1.5 text-center'>
                                    {j + 1}
                                  </td>
                                  {/* Số phiếu kiểm tra */}
                                  <td className='whitespace-nowrap border p-1.5'>
                                    {report.commandQCCode}
                                  </td>
                                  <td className='whitespace-nowrap border p-1.5 text-right'>
                                    {/* ngày kiểm tra */}
                                    {moment(report.qcTime).format('DD/MM/YYYY')}
                                  </td>
                                  {/* Lệnh sản xuất */}
                                  <td className='whitespace-nowrap border p-1.5 text-right'>
                                    {report.workOrderCode}
                                  </td>
                                  {/* Số thẻ treo */}
                                  <td className='whitespace-nowrap border p-1.5 text-right'>
                                    {report.kssxnUmberIndex}
                                  </td>
                                  {/* Mã và tên sản phẩm */}
                                  <td className='whitespace-nowrap border p-1.5 !max-w-[200px] truncate cursor-default'>
                                    <Tooltip
                                      title={`${report.productCodeAndName}`}
                                    >
                                      <span>{report.productCodeAndName}</span>
                                    </Tooltip>
                                  </td>
                                  {/* Công đoạn */}
                                  <td className='whitespace-nowrap border p-1.5'>
                                    {report.stepCodeAndName}
                                  </td>
                                  {/* Số SP/Tờ/CĐ */}
                                  <td className='whitespace-nowrap border p-1.5 text-center'>
                                    {report.quantityProduction}
                                  </td>
                                  {/* Số lượng sản xuất */}
                                  <td className='whitespace-nowrap border p-1.5 text-center'>
                                    {report.quantityProduction}
                                  </td>
                                  {/* Chỉ tiêu kiểm tra */}
                                  <td
                                    onClick={() =>
                                      handleOpenModal(
                                        report.testTargetProduction
                                      )
                                    }
                                    className='whitespace-nowrap border p-1.5 font-medium cursor-pointer text-report_header hover:text-blue-500'
                                  >
                                    {report.testTargetName}
                                  </td>
                                  {/* Số lượng kiểm mẫu */}
                                  <td className='whitespace-nowrap border p-1.5 text-center'>
                                    {report.quantitySample}
                                  </td>
                                  {/* Số lượng đạt */}
                                  <td className='whitespace-nowrap border p-1.5 text-center'>
                                    {report.quantityOK}
                                  </td>
                                  {/* Số lượng không đạt */}
                                  <td className='whitespace-nowrap border p-1.5 text-center text-danger'>
                                    {report.quantityNotOK}
                                  </td>
                                  {/* ĐVT công đoạn */}
                                  <td className='whitespace-nowrap border p-1.5 text-center'>
                                    {report.unit}
                                  </td>
                                  {/* Lỗi */}
                                  {/* <td className="whitespace-nowrap border p-1.5 !max-w-[200px] truncate cursor-default">
                                    <Tooltip title={`${report.errorName}`}>
                                      <span>{report.errorName}</span>
                                    </Tooltip>
                                  </td> */}
                                  {/* Ghi chú */}
                                  <td className='whitespace-nowrap border p-1.5 !max-w-[200px] truncate cursor-default'>
                                    <Tooltip title={`${report.description}`}>
                                      <span>{report.description}</span>
                                    </Tooltip>
                                  </td>
                                </tr>
                              ))}
                            <tr>
                              <td
                                colSpan={100}
                                className={`border p-1.5 font-medium ${item.resultQC === 'DAT'
                                    ? 'text-green-600'
                                    : item.resultQC === 'KHONGDAT'
                                      ? 'text-orange-600'
                                      : item.resultQC === 'KHONGDAT'
                                        ? 'text-red-600'
                                        : ''
                                  } uppercase`}
                              >
                                KẾT QUẢ:{' '}
                                {item.resultQCName
                                  ? item.resultQCName
                                  : 'CHƯA KẾT LUẬN'}
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          className='border whitespace-nowrap px-2 py-1 text-center'
                          colSpan={100}
                        >
                          Không tìm thấy dữ liệu
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={detailProduction !== null && openModel}
          onClose={handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          maxWidth='md'
        >
          <DialogTitle
            align='center'
            fontSize={'16px'}
            fontWeight='700'
            id='alert-dialog-title'
          >
            THÔNG TIN KIỂM TRA CHI TIẾT
          </DialogTitle>
          <DialogContent>
            <div className='text-default grid sm:grid-cols-2 border p-3'>
              <div className='grid grid-cols-3'>
                <span className='font-medium'>Lệnh sản xuất:</span>
                <span className='col-span-2'>
                  {detailProduction && detailProduction.workOrderCode}
                </span>
              </div>
              <div className='grid grid-cols-3'>
                <span className='font-medium'>Công đoạn kiểm tra:</span>
                <span className='col-span-2'>
                  {detailProduction && detailProduction.stepCode}
                </span>
              </div>
              <div className='grid grid-cols-3'>
                <span className='font-medium'>Số thẻ treo:</span>
                <span className='col-span-2'>
                  {detailProduction && detailProduction.numberPallet}
                </span>
              </div>
              <div className='grid grid-cols-3'>
                <span className='font-medium'>Chỉ tiêu kiểm tra:</span>
                <span className='col-span-2'>
                  {detailProduction && detailProduction.testTargetName}
                </span>
              </div>
            </div>
            <div className={``}>
              <table className='w-full text-default table-auto break-all border-collapse space-collapse my-3.5'>
                <thead className=' text-white bg-[#4682B4]'>
                  <tr>
                    {columnDetails?.map((item, index) => {
                      if (item.visible) {
                        return (
                          <th
                            key={index}
                            scope='col'
                            className={`${item.visible ? '' : 'hidden'
                              } py-2 px-2 border text-left ${item.align
                              } break-normal font-medium text-default`}
                          >
                            {item.columnName}
                          </th>
                        );
                      }
                    })}
                  </tr>
                </thead>
                <tbody>
                  {detailProduction &&
                    detailProduction.detailTestTargetProduction.length ? (
                    detailProduction.detailTestTargetProduction.map(
                      (item, index) => {
                        //   if(index===0){handleSetDate(item.ngay)}
                        //   if(item.ngay===date)handleSetCheckDate(false)
                        //   if(item.ngay!==date)
                        //     handleSetCheckDate(true)
                        //   }
                        return (
                          <tr key={index} className='break-normal'>
                            {/* STT */}
                            <td className='border p-1.5 text-center'>
                              {index + 1}
                            </td>
                            {/* Thời gian kiểm tra */}
                            <td className='border p-1.5'>
                              {moment(item.qcTime).format('DD/MM/YYYY HH:mm')}
                            </td>
                            {/* Nhân viên kiểm tra */}
                            <td className='border p-1.5'>{item.qcBy}</td>
                            {/* Số lượng kiểm mẫu */}
                            <td className='border p-1.5'>
                              {item.quantitySample}
                            </td>
                            {/* Số lượng đạt */}
                            <td className='border p-1.5 text-center'>
                              {item.quantityOK}
                            </td>
                            {/* Số lượng đạt */}
                            <td className='border p-1.5 text-center'>
                              {item.quantityNotOK}
                            </td>
                            {/* Đơn vị tính công đoạn */}
                            <td className='border p-1.5 text-center'>
                              {item.unit}
                            </td>
                            {/* Lỗi */}
                            <td className='border p-1.5'>{item.errorName}</td>
                            {/* Cách nhận biết */}
                            <td className='border p-1.5'>{item.toKnow}</td>
                            {/* Nguyên nhân  */}
                            <td className='border p-1.5'>{item.reason}</td>
                            {/* Ghi chú  */}
                            <td className='border p-1.5'>{item.description}</td>
                            {/* Kết luận */}
                            <td
                              className={`border p-1.5 font-medium ${item.conclusion === 'DAT'
                                  ? 'text-green-600'
                                  : item.conclusion === 'KHONGDAT'
                                    ? 'text-orange-600'
                                    : item.conclusion === 'KHONGDAT'
                                      ? 'text-red-600'
                                      : ''
                                }`}
                            >
                              {item.conclusionName}
                            </td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td
                        className='border whitespace-nowrap px-2 py-1 text-center'
                        colSpan={12}
                      >
                        Không tìm thấy dữ liệu
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  });
}
